import React from 'react'
import classes from './style.module.scss'

export const PositionWrapper = ({ children }) => {
	return <div className={classes.wrapper}>{children}</div>
}
